// extracted by mini-css-extract-plugin
export default {"container":"InformationPill_container__CDu1C","icon_container":"InformationPill_icon_container__SKyM2","text":"InformationPill_text__eQFYK"};